import React from "react";
import Header from "../components/Header";
import BottomSection from "../components/BottomSection";

const AboutUs = () => {
  return (
    <div>
      <Header />
      {/* <div
        className="mx-auto"
        style={{
          background: "rgba(255, 157, 0, 0.12)",
          width: "55%",
          height: 267,
          borderRadius: 32,
        }}
      ></div> */}
      <div className='max-w-3xl mx-auto my-10 px-6'>
        <h1 className='text-3xl font-bold text-center text-gray-800'>
          About Us
        </h1>

        <section className='mt-8'>
          <h2 className='text-xl font-semibold text-gray-800'>
            About HomeOwner
          </h2>
          <div className='mt-1'>
            At HomeOwner, we are on a mission to simplify the journey of
            managing your rental properties. Born from real-life experiences, we
            have created an intuitive mobile app designed specifically for
            Canadian landlords, aimed at eliminating the stress, uncertainty,
            and financial risk of property management.
          </div>
        </section>

        <section className='mt-8'>
          <h2 className='text-xl font-semibold text-gray-800'>Our Story</h2>
          <div className='mt-1'>
            <p className='mt-2'>
              HomeOwner began with a personal nightmare. I am Chetan, and a few
              years ago, my wife Pooja and I rented out our house. Like many of
              you, we became landlords simply to build a secure future for our
              two young kids. We learned the hard way that the system is not
              built to protect families like ours.
            </p>
            <p className='mt-2'>
              When the rent started slipping, the anxiety set in. Every month
              became a frustrating cycle of sending awkward texts asking for
              money, waiting days for a reply, and getting empty promises. We
              wanted to be understanding without looking weak, but the constant,
              uncomfortable follow-ups were emotionally exhausting. Because we
              dreaded those conversations, we waited too long to start the
              formal legal process.
            </p>
            <p className='mt-2'>
              By the time we finally filed a complaint, we were already bleeding
              money. Then we hit the brick wall of the tribunal board. Even with
              our lease paperwork in order, trying to manually piece together a
              perfect timeline of exact transaction dates, partial payments, and
              ignored messages for the hearing was a painful, frustrating
              process. Add in the massive systemic backlogs, and we had to wait
              7 agonizing months just to get in front of an adjudicator.
            </p>
            <p className='mt-2'>
              The board eventually put the tenants on a payment plan, but they
              paid for two months and vanished. We came back to a completely
              abandoned, destroyed house. Between the unpaid rent, the shattered
              windows, and the massive repair bills, we lost over $40,000.
            </p>
            <p className='mt-2'>
              We lost that money because we relied on goodwill and manual
              follow-ups instead of an automated system. I built the HomeOwner
              app so no other small Canadian landlord ever has to go through
              that.
            </p>
            <p className='mt-2'>
              The app takes the emotion and frustration out of the process. It
              handles the uncomfortable conversations for you by automatically
              following up on late rent, so you never have to send another
              awkward text. It perfectly logs every transaction date, reminder,
              and document in the background, ensuring you always have a
              flawless, time-stamped record ready to go.
            </p>
          </div>
        </section>

        <section className='mt-8'>
          <h2 className='text-xl font-semibold text-gray-800'>What We Do </h2>

          <div className='ml-5  mt-2'>
            <p className='text-gray-600'>
              HomeOwner protects you every step of the way
            </p>
            <ul className='list-disc text-gray-600 mt-2 font-semibold ml-5'>
              <li>
                <b>Rental Management: </b> Simplified tenant interactions,
                streamlined rental agreements, and automated rent reminders that
                take the awkwardness out of collecting money.
              </li>
              <li>
                <b>Legal Notice Guidance: </b> Province-specific information
                based on local rental board rules. We provide clear guidance and
                access to essential templates for handling non-payments and
                other tenancy issues correctly.
              </li>
              <li>
                <b>Secure Document Vault: </b> Keep all your leases, risk
                checklists, and communication records safe in one place. If you
                ever have to go to the board, your paper trail is organized and
                timestamped.
              </li>
              <li>
                <b>Property Maintenance: </b> Checklists, schedules, and alerts
                to help you stay proactive about property upkeep, ensuring your
                investment stays in top shape.
              </li>
              <li>
                <b>Expense & Tax Tracking: </b> Log property expenses through
                the year and download a year-end report mapped to CRA Form
                T776, so tax time is organized instead of stressful.
              </li>
            </ul>
          </div>
        </section>

        <section className='mt-8'>
          <h2 className='text-xl font-semibold text-gray-800'>
            Why Choose HomeOwner?
          </h2>

          <div className='ml-5  mt-2'>
            <ul className='list-disc text-gray-600 mt-2 font-semibold ml-5'>
              <li>
                <b>Built for Canadians: </b> Tailored specifically to Canadian
                real estate and provincial tenancy markets.
              </li>
              <li>
                <b>Automated Protection: </b> Smart workflows that catch missed
                payments immediately so you never fall behind.
              </li>
              <li>
                <b>Comprehensive Advice: </b>Step-by-step guidance to
                confidently handle tenant onboarding, routine inspections, and
                late rent issues.
              </li>
              <li>
                <b>Secure and Compliant: </b> Your data security is our
                priority, ensuring your vital landlord records are safe and
                accessible whenever you need them.
              </li>
            </ul>
          </div>
        </section>

        <section className='mt-8'>
          <h2 className='text-xl font-semibold text-gray-800'>
            Meet the Team{" "}
          </h2>
          <div className='mt-1'>
            Behind HomeOwner is a dedicated team of developers who are also
            everyday landlords. Driven by real-life experiences and a deep
            understanding of how heavily the rules favor tenants, we are
            committed to creating practical, automated solutions. By actively
            incorporating feedback from local landlords, we continuously build
            and refine features that directly address real-world needs.
          </div>
        </section>

        <section className='mt-8'>
          <h2 className='text-xl font-semibold text-gray-800'>Our Promise</h2>
          <div className='mt-1'>
            We are dedicated to building the ultimate shield for self-managing
            landlords. Driven by your feedback, we remain committed to
            innovation and refining our app, ensuring it remains your trusted
            companion in protecting your rental income and your property.
          </div>
        </section>
      </div>

      <BottomSection />
    </div>
  );
};

export default AboutUs;
